import React, { FC, forwardRef } from "react";
import {CustomContentProps, useSnackbar, VariantType} from "notistack";
import {Box, SnackbarContent} from "@mui/material";
import { styled } from '@mui/material'
import Typography from "@mui/material/Typography";
import Close from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

const Root = styled(Box)<{variant: VariantType}>(({theme, variant}) => ({
	borderRadius: 24,
	padding: '16px 24px',
	maxWidth: 420,
	minWidth: 330,
	[theme.breakpoints.down('tablet')]: {
		maxWidth : 360,
	},
	backgroundColor: variant === 'error' ? theme.palette.common.toastBgRed
		: variant === 'success' ? theme.palette.common.toastBgGreen
			: theme.palette.common.toastBgNatural
}));

const Title = styled(Box)({
	width: '100%',
	display: "flex",
	justifyContent: 'space-between',
	alignItems: 'center',
});

const Description = styled(Box)({
	marginTop: 12,
	width: '100%',
});

const AppSnackbarContent = forwardRef<HTMLDivElement, CustomContentProps>(
	({ id, message, description, ...other }, ref) => {
		const { closeSnackbar } = useSnackbar();
		return (
			<Root ref={ref} role="alert" {...other}>
				<Title>
					<Typography variant="appMediumBold" color="common.N050">{message}</Typography>
					<IconButton
						onClick={() => closeSnackbar(id)}
						edge="end"
						sx={{'&:hover': { backgroundColor: 'transparent' } }}
					>
						<Close />
					</IconButton>
				</Title>
				{description && (
					<Description>
						<Typography variant="appSmallRegular" color="common.N050">{description}</Typography>
					</Description>
				)}
			</Root>
		)
})

export default AppSnackbarContent;

